/* istanbul ignore file */
import { array as codecArray, number as codecNumber, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const CreateSectionCourseDataParser = 
/* #__PURE__ */ parsers.object([
    ['name', codecString],
    ['userIds', /* #__PURE__ */ codecArray(codecNumber), 'user_ids'],
]);
export class CreateSectionCourseData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CreateSectionCourseDataParser.decode(input).map(res => new CreateSectionCourseData(res));
    }
    static unsafeDecode(input) {
        return CreateSectionCourseData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CreateSectionCourseDataParser.encode(data);
    }
    static schema() {
        return CreateSectionCourseDataParser.schema();
    }
}
